import {api} from '../utils/environment'
import http from '../utils/http'

export async function readCustomerTree(customerId: string) {
  const url = `${api}/customer_tree?customer_id=${customerId}`
  return await http.get(url)
}
